var module = angular.module('octopusApp.users');

module.controller('SignInController', function ($scope, $q, $rootScope, $state, octopusLog, octopusRepository, octopusClient, octopusAuthenticator, $location, $window, busy, octopusPermissionSet, octopusFeatures) {
    $scope.fields = {
        username: '',
        password: '',
        rememberMe: false
    };

    var root = $scope.rootDocument = octopusClient.rootDocument();

    var isSubmitting = $scope.isSubmitting = busy.create();
    var isRedirecting = $scope.isRedirecting = busy.create();

    var error = $location.search()['error'];
    if (error) {
        isSubmitting.error = {Errors: [error]};
    }

    $scope.nonFormsAuthenticationProviders = _.filter(root.AuthenticationProviders, function (p) {
        return !p.FormsLoginEnabled && p.Name !== 'Active Directory' && !p.IsGuestProvider;
    });
    $scope.formsAuthenticationProviders = _.filter(root.AuthenticationProviders, function (p) {
        return p.FormsLoginEnabled && !p.IsGuestProvider;
    });

    $scope.anyFormsAuthenticationProviders = _.any($scope.formsAuthenticationProviders);
    $scope.anyNonFormsAuthenticationProviders = _.any($scope.nonFormsAuthenticationProviders);

    $scope.formsProvidersWithLinks = _.filter(root.AuthenticationProviders, function (p) {
        return p.Name === 'Active Directory';
    });

    $scope.anyAuthenticationProviders = $scope.anyFormsAuthenticationProviders || $scope.anyNonFormsAuthenticationProviders || $scope.formsProvidersWithLinks.length > 0;

    $scope.isGuestProviderEnabled = _.any(root.AuthenticationProviders, function (p) {
        return p.IsGuestProvider;
    });
    if ($scope.isGuestProviderEnabled) {
        $scope.guestProvider = _.filter(root.AuthenticationProviders, function (p) {
            return p.IsGuestProvider;
        })[0];
    }
    $scope.guestPanelVisible = $scope.isGuestProviderEnabled && !error;
    $scope.hideGuestPanel = function () {
        $scope.guestPanelVisible = false;
    };

    if (root.AutoLoginEnabled && !error && !$scope.anyFormsAuthenticationProviders &&
        ($scope.nonFormsAuthenticationProviders.length === 1 || $scope.formsProvidersWithLinks.length === 1) && !$scope.guestPanelVisible) {

        $scope.shouldAutoLogin = true;
        // create a promise here so the loading spinner becomes visible until the redirect actually happens.
        isRedirecting.promise($q(function (resolve, reject) {}));
    }

    var redirectAfterLogin = function (success) {

        return octopusRepository.Users.getPermissions(success).then(function(permissions){
            octopusAuthenticator.setCurrentPrincipal(success, permissions.Permissions);
            octopusPermissionSet.refresh();
            octopusFeatures.refresh();
            octopusLog.log("Sign in successful, redirecting");
            $location.search('error', null);
            if ($rootScope.redirectAfterFormsLoginTo) {
                octopusLog.log("Redirecting to " + $rootScope.redirectAfterFormsLoginTo);
                if ($rootScope.redirectAfterFormsLoginTo.startsWith('http')) {
                    $window.location.href = $rootScope.redirectAfterFormsLoginTo;
                } else {
                    $location.path($rootScope.redirectAfterFormsLoginTo);
                }
            } else {
                octopusLog.log("Redirecting to /");
                $state.go('app');
            }
        }, function(error) {
            octopusLog.log(error);
            var message = "The sign in succeeded but we failed to get the resultant permissions for this user account. ";

            var reason = (error.StatusCode === 401)
                ? "This can happen if the Octopus authentication cookie is blocked."
                : "There was a problem communicating with the Octopus Server: " + error.ErrorMessage;

            throw { Errors: [message + reason] };
        });
    };

    $scope.handleSignInError = function(error) {
        if (error.Errors && error.Errors.length > 0) {
            throw { Errors: error.Errors };
        } else if (error.ErrorMessage) {
            throw {Errors: [error.ErrorMessage] };
        } else {
            throw { Errors: [error] };
        }
    };

    $scope.signIn = function() {
        if (isSubmitting.busy) {
            return;
        }

        var user = { Username: $scope.fields.username, Password: $scope.fields.password, RememberMe: $scope.fields.rememberMe };

        octopusLog.log("Attempting to sign in: " + user.Username);

        isSubmitting.promise(octopusRepository.Users.signIn(user).then(redirectAfterLogin, $scope.handleSignInError));
    };

    $scope.signInAsGuest = function() {
        if (!$scope.guestProvider) {
            return;
        }

        if (isSubmitting.busy) {
            return;
        }
        var user = { Username: "guest", Password: "guest", RememberMe: true };

        octopusLog.log("Attempting to sign in: " + user.Username);

        isSubmitting.promise(octopusRepository.Users.signIn(user).then(redirectAfterLogin, $scope.handleSignInError));
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/users/controllers/sign_in_controller.js
// module id = 1356648542341301
// module chunks = 1